import React from 'react';
import { GUARDIAN_RELATIONSHIPS, DEFAULT_GUARDIAN_RELATIONSHIP } from '../utils/guardianRelationships';

export default function GuardianRelationshipSelect({ value, onChange, style, required }) {
    return (
        <select
            value={value || DEFAULT_GUARDIAN_RELATIONSHIP}
            onChange={e => onChange(e.target.value)}
            required={required}
            style={style}
        >
            {GUARDIAN_RELATIONSHIPS.map(r => (
                <option key={r.value} value={r.value}>{r.label}</option>
            ))}
        </select>
    );
}
